<template>
  <a-modal
    :title="readFlag=='0' ? '查看未读' : '查看已读'"
    :visible="visible"
    :confirmLoading="loading"
    destroyOnClose
    cancelText="关闭"
    width="800px"
    :maskClosable="false"
    :okButtonProps="{
      style:{
         display: 'none'
      }
    }"
    @cancel="$emit('update:visible', false)"
  >
    <base-screen title="筛选条件" :open="true">
      <a-form style="width: auto" :form="screenForm" layout="inline" @submit.prevent="handleScreenSubmit">
        <a-form-item label="公司">
          <a-input placeholder="请输入" v-decorator="['companyName']"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">查询</a-button>
          <a-button @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
    </base-screen>
    <base-table
      class="custom-table"
      :columns="readFlag=='0' ? columnsNoRead : columnsRead"
      :dataSource="tableData"
      :pagination="page"
      :rowKey="record => record.companyId"
      :loading="loading"
      @change="handleTableChange"
    >
    </base-table>
  </a-modal>
</template>

<script>
import { notice } from '@/api'

export default {
  name: 'PageNoticeRead',
  props: {
    visible: Boolean,
    noticeWorkId: String,
    readFlag: String
  },
  beforeCreate () {
    this.columnsRead = [
      {
        title: '企业名称',
        dataIndex: 'companyName'
      },
      {
        title: '阅读账号',
        dataIndex: 'readAccout'
      },
      {
        title: '阅读时间',
        dataIndex: 'createTime'
      }
    ]
    this.columnsNoRead = [
      {
        title: '企业名称',
        dataIndex: 'companyName'
      },
      {
        title: '主账号',
        dataIndex: 'readAccout'
      },
      {
        title: '联系人',
        dataIndex: 'name'
      },
      {
        title: '联系电话',
        dataIndex: 'phone'
      }
    ]
  },

  data () {
    return {
      screenForm: this.$form.createForm(this),
      loading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: []
    }
  },
  watch: {
    async visible (newVal) {
      await this.$nextTick()
      if (newVal) {
        this.getTableReadData()
      }
    }
  },
  methods: {
    async getTableReadData () {
      let screenData = this.screenForm.getFieldsValue()
      this.loading = true
      if (this.readFlag === '0') {
        let { code, msg, data, page } = await notice.pageNoticeNoRead({
          ...screenData,
          ...this.page,
          noticeWorkId: this.noticeWorkId
        })
        this.tableData = data
        this.loading = false
        if (code !== 0) return this.$message.error(msg || '数据获取失败')
        this.page.total = page.total
      } else {
        let { code, msg, data, page } = await notice.pageNoticeRead({
          ...screenData,
          ...this.page,
          noticeWorkId: this.noticeWorkId
        })
        this.tableData = data
        this.loading = false
        if (code !== 0) return this.$message.error(msg || '数据获取失败')
        this.page.total = page.total
      }
    },
    handleScreenSubmit () {
      this.page.current = 1
      this.getTableReadData()
    },
    handleReset () {
      this.screenForm.resetFields()
      this.page.current = 1
      this.getTableReadData()
    },
    handleTableChange ({ current }) {
      this.page.current = current
      this.getTableReadData()
    }
  }
}
</script>

<style lang="less" scoped>
.wrap-cards {
  height: 100%;
}
.tree-card {
  min-width: 250px;
  min-height: 100%;
  user-select: none;
}
.table-card {
  flex: 1;
  min-height: 100%;
}
.table-page-search-wrapper {
  margin-top: -9px;
  margin-bottom: 16px;
  padding-left: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
}
.table-page-search-wrapper-operation {
  padding-bottom: 25px;
}
.list-blue {
  font-size: 14px;
  color: @main-color;
}

.list-red {
  font-size: 14px;
  color: @warning-color;
}
#sifting {
  position: absolute;
  right: 20px;
  top: 0px;
  line-height: 50px;
}

.table-page-search-wrapper {
  padding-top: 9px;
}
</style>
